import React from "react";

import ContactForm from "./ContactForm"

const PurchaseOrderContactForm = (props) => {
  return <ContactForm type="purchase_order" tradeDocId={props.match.params.id} />
}

export default PurchaseOrderContactForm;




// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/PurchaseOrderContactForm.js